<div *ngIf="loading" class="text-center mt-5">
  <div class="spinner-border" role="status"></div>
</div>

<ng-container *ngIf="rental$ | async as rental">

  <div class="container mt-4">
    <h2>{{ rental.title }}</h2>
    <p class="text-muted">{{ rental.address }}</p>

    <!-- Carousel -->
    <div id="rentalCarousel" class="carousel slide" data-bs-ride="carousel">
      <div class="carousel-inner">
        <div
          class="carousel-item"
          *ngFor="let img of rental.images; let i = index"
          [class.active]="i === selectedImageIndex"
        >
          <img
            [src]="img"
            class="d-block rental-image"
            [alt]="rental.title"
            (click)="selectImage(i)"
            data-bs-toggle="modal"
            data-bs-target="#lightboxModal"
          />
        </div>
      </div>

      <button class="carousel-control-prev" type="button" data-bs-target="#rentalCarousel" data-bs-slide="prev">
        <span class="carousel-control-prev-icon"></span>
      </button>

      <button class="carousel-control-next" type="button" data-bs-target="#rentalCarousel" data-bs-slide="next">
        <span class="carousel-control-next-icon"></span>
      </button>
    </div>

    <!-- Thumbnails -->
    <div class="d-flex justify-content-center flex-wrap mt-2">
      <img
        *ngFor="let img of rental.images; let i = index"
        [src]="img"
        class="img-thumbnail m-1"
        [class.border-primary]="i === selectedImageIndex"
        style="width:80px;height:60px;object-fit:cover;cursor:pointer;"
        (click)="goToSlide(i)"
      />
    </div>

    <!-- Details -->
    <div class="mt-4">
      <p class="h5 text-primary">${{ rental.price }} / month</p>
      <div
        class="rental-description"
        [innerHTML]="rental.description">
      </div>

      <ul class="list-inline">
        <li class="list-inline-item"><strong>{{ rental.bedrooms }} Beds</strong></li>
        <li class="list-inline-item"><strong>{{ rental.bathrooms }} Baths</strong></li>
        <li class="list-inline-item"><strong>{{ rental.sqft }} sqft</strong></li>
      </ul>
    </div>

    <!-- Apply Button -->
    <div class="text-center mt-4">
      <button
        class="btn-apply"
        [disabled]="redirecting"
        (click)="goToApplication()"
      >
        <span *ngIf="!redirecting">Apply Now</span>
        <span *ngIf="redirecting">Redirecting...</span>
      </button>
    </div>

  </div>

  <!-- Lightbox Modal -->
  <div
    class="modal fade"
    id="lightboxModal"
    tabindex="-1"
    aria-hidden="true"
  >
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content bg-transparent border-0">
        <div class="modal-body p-0 text-center">
          <img
            [src]="rental.images[selectedImageIndex]"
            class="img-fluid rounded"
            alt="Rental image"
          />
        </div>
        <button
          type="button"
          class="btn-close position-absolute top-0 end-0 m-2"
          data-bs-dismiss="modal"
        ></button>
      </div>
    </div>
  </div>

</ng-container>
